import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FiWrapperTableAdditionalColumns } from '../../../fi-wrapper-table/fi-wrapper-table-additional-columns';

@Component({
    selector: 'fi-checklist2-list-unit-name',
    templateUrl: './fi-checklist2-list-unit-name.component.html',
    styleUrl: './fi-checklist2-list-unit-name.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-checklist2-list-name' },
    providers: [{ provide: FiWrapperTableAdditionalColumns, useExisting: FiChecklist2ListUnitNameComponent }],
    standalone: false,
})
export class FiChecklist2ListUnitNameComponent extends FiWrapperTableAdditionalColumns {}
